
Array.prototype.diff = function (a) {
    return this.filter(function (i) {
        return a.indexOf(i) < 0;
    });
};

Array.prototype.max = function () {
    return Math.max.apply(null, this);
};

Array.prototype.min = function () {
    return Math.min.apply(null, this);
};

Date.prototype.fromDuration = function(s) {
    var time = s.split('.');
    var hours = time[0].split('T')[1].split('H')[0];
    var minutes = time[0].split('H')[1].split('M')[0];
    return digitize(hours) + ":" + digitize(minutes)
};


String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

Object.fromEntries = require('fromentries');

Date.prototype.isValid = function () {
    return !isNaN(this.getTime());
};
